import React, { useEffect, useState } from 'react';
import logo from '../../assets/img/unusual-studio-logo.png';
import { ApiService } from '../../services/api-service';
import { container } from 'tsyringe';
import { useSharedState } from '../../utils/helpers';

import InlineEdit from '../utils/InlineEdit';
import './TopToolbar.scss';
import GoLive from '../layout/GoLive';
import DestinationStatus from './liveStatus/DestinationStatus';
import DestinationMenu from './liveStatus/DestinationMenu';
import { ProducerType } from '../../models/producerClass';
import LiveRecordStatus from './liveStatus/LiveRecordStatus';
import { useSelector } from 'react-redux';
import { ActionType, GroupType } from '../../models/actionClass';
import { LightTooltip } from '../tooltip/LightTooltip';

const TopToolbar = () => {

    const [apiService] = useState(container.resolve(ApiService));
    const [eventName, setEventName] = useSharedState(apiService.eventName$);

    const liveStreamRunning = useSelector((state: any) => state.layout.liveStreamRunning);

    const onValidate = (text) => {
        console.log('validate', text);
        setEventName(text);
        localStorage.setItem('eventName', text);
        apiService.updateReason = { group: GroupType.CHANNEL, action: ActionType.RENAME, value: text };
        apiService.saveChannel('Event name update');
        window.dispatchEvent(new Event('resize'));
    }

    useEffect(() => {
        console.log('eventNane changed', eventName);
    }, [eventName]);

    const toggleRegisterPopup = () => {
        apiService.toggleRegisterPopup();
    }

    return (
        <header className="top-toolbar">
            <ul>
                <li key="item1" className="item1">
                    <img src={logo} alt="Studio Logo" className="logo" />
                </li>
                <li key="sep1" className="separator"></li>
                <li key="item2" className="item2">
                    <div className="event-orig">Event</div>
                    <div className="event-title">
                        {eventName}
                        {/* <InlineEdit
                            height={24}
                            text={eventName}
                            placeHolder="Enter an event name ..."
                            showSaving={true}
                            onSetText={(text) => onValidate(text)}
                        ></InlineEdit> */}
                    </div>
                </li>
                {/* <li key="sep3" className="separator"></li> */}


                <li key="destinations-status" className="destinations-status">
                    {/* <DestinationStatus></DestinationStatus>
                    <div className="separator"></div>

                    <DestinationMenu></DestinationMenu>
                    <div className="separator"></div>

                    {liveStreamRunning && <>
                        <LiveRecordStatus></LiveRecordStatus>
                        <div className="separator"></div>
                        <div className="rec-container">
                            <div className="rec-indicator">
                                <div className="rec-rect"></div>
                            </div>
                            <div className="rec-text">REC</div>
                        </div>
                    </>}
                    {!liveStreamRunning && <>
                        <div className="rec-container">
                            <div className="rec-indicator">
                                <div className="rec-round"></div>
                            </div>
                            <div className="rec-text">REC</div>
                        </div>
                    </>} */}
                    <div className="rec-container" onClick={() => toggleRegisterPopup()}>
                        <div className="rec-indicator">
                            <div className="rec-round"></div>
                        </div>
                        <div className="rec-text">REC</div>
                    </div>
                    <GoLive></GoLive>
                </li>
            </ul>
        </header>
    );
}

export default TopToolbar;